// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"279d2aa9","404":"f93d14c6","787":"9179d0e5"}[chunkId] + ".chunk.js";
};